import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './LimitsList.styles';
// import { Limit, mockLimits } from '@/mock-data/limits';
// import { Accordion } from '@/components/UI/Accordion/Accordion';
// import { setSuffix } from '@/utils/helpers';
// import { Typography } from '@/components/UI/Typography/Typography.styles';

export const LimitsList = () => {
  const { t } = useTranslation();

  return (
    <div>
      <S.Title $variant="1">
        {t('pages.cabinet.remaining_placements_in_your_categories')}
      </S.Title>

      {/* <Accordion<Limit> */}
      {/*   data={mockLimits} */}
      {/*   renderHead={item => { */}
      {/*     const amount = item.free.amount + item.paid.amount; */}

      {/*     return ( */}
      {/*       <S.Head> */}
      {/*         <S.ImgBox> */}
      {/*           <img src={item.image} alt="" loading="lazy" /> */}
      {/*         </S.ImgBox> */}
      {/*         <S.Names> */}
      {/*           <S.SubCategory $variant="1"> */}
      {/*             {item.subcategoryName} */}
      {/*           </S.SubCategory> */}
      {/*           <S.Category $variant="1">{item.categoryName}</S.Category> */}
      {/*         </S.Names> */}
      {/*         <S.Stats> */}
      {/*           <S.Stat $variant="1" $isRed={!amount}> */}
      {/*             {amount} */}
      {/*           </S.Stat> */}
      {/*           <Typography.Caption $variant="1"> */}
      {/*             {!amount */}
      {/*               ? ` /${t('pages.cabinet.until_date', { date: '25.10' })}` */}
      {/*               : ''} */}
      {/*           </Typography.Caption> */}
      {/*         </S.Stats> */}
      {/*       </S.Head> */}
      {/*     ); */}
      {/*   }} */}
      {/*   renderBody={item => ( */}
      {/*     <S.Body> */}
      {/*       <Typography.Body $variant="3"> */}
      {/*         {t('pages.cabinet.free_placements')} —{' '} */}
      {/*         <S.BodySpan as="span" $isRed={!item.free.amount}> */}
      {/*           {t(setSuffix(i18n, String(item.free.amount), 'common.n_ads'), { */}
      {/*             n: item.free.amount, */}
      {/*           })} */}
      {/*         </S.BodySpan>{' '} */}
      {/*         {t('pages.cabinet.until_date', { date: '25.10.2023' })} */}
      {/*       </Typography.Body> */}
      {/*       <Typography.Body $variant="3"> */}
      {/*         {t('pages.cabinet.paid_placements')} —{' '} */}
      {/*         {t(setSuffix(i18n, String(item.paid.amount), 'common.n_ads'), { */}
      {/*           n: item.paid.amount, */}
      {/*         })} */}
      {/*       </Typography.Body> */}
      {/*     </S.Body> */}
      {/*   )} */}
      {/* /> */}
    </div>
  );
};
